import { Directive } from '@angular/core'
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms'
import { nonEmptyValidator } from '../validators'

@Directive({
  selector: '[nonEmpty]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: NonEmptyValidatorDirective,
    multi: true,
  }],
})
export class NonEmptyValidatorDirective implements Validator {
  private validator = nonEmptyValidator()

  validate (control: AbstractControl): ValidationErrors | null {
    return this.validator(control)
  }
}
